import { render, staticRenderFns } from "./userAccountNew.vue?vue&type=template&id=0daea3d0&"
import script from "./userAccountNew.vue?vue&type=script&lang=js&"
export * from "./userAccountNew.vue?vue&type=script&lang=js&"
import style0 from "./userAccountNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports